import React, { useState } from "react";
import axios from "axios";
import { useHistory, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import Slide from "@material-ui/core/Slide";

import LinearProgress from "@material-ui/core/LinearProgress";
import Alert from "@material-ui/lab/Alert";

import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import bannerEmail from "../../assets/images/email.svg";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
const useStyles = makeStyles(() => ({
  root: {
    height: "100vh",
    background: "white",
  },
  paddingStyle: {
    padding: "0px 80px",
  },
  marginBottomStyle: {
    marginBottom: "15px",
  },

  divStyle: {
    width: "70%",
    margin: "auto",
    "& img": {
      maxWidth: "100%",
    },
  },

  banner: {
    marginLeft: 90,
  },
  fontStyle: {
    fontSize: "14px",
  },
  fieldWrapper: {
    marginBottom: 30,
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 15,
    },
  },
  buttonStyle: {
    padding: "10px 32px",
    fontSize: "16px",
    color: "white",
    fontWeight: 600,
    textTransform: "capitalize",
    borderRadius: "4px",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
  },
  error: {
    marginBottom: 15,
  },
}));
const OtpSend = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let data = {
        email: location.state.email,
        otp: otp,
      };
      let response = await axios({
        url: "/api/v1/public/auth/forgot-password/verify-otp",
        method: "post",
        data: data,
      });
      history.push({
        pathname: "/reset-password",
        state: { email: location.state.email, otp: otp },
      });
    } catch (error) {
      let er = error.response && error.response.data.errors.toString();

      enqueueSnackbar(er, {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
        TransitionComponent: Slide,
      });
    }

    setLoading(false);
  };

  return (
    <div>
      <Grid
        container
        direction="column"
        justifyContent="space-between"
        className={classes.root}
      >
        <Grid>
          <Header />
        </Grid>
        <Grid>
          <Grid container alignItems="center" className={classes.paddingStyle}>
            <Grid item xs={6}>
              <div
                className={classes.divStyle}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img src={bannerEmail} alt="" className={classes.banner} />
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={classes.divStyle}>
                <Typography variant="h3" className={classes.marginBottomStyle}>
                  OTP Sent!
                </Typography>
                <Typography variant="h6" className={classes.marginBottomStyle}>
                  An OTP has been sent to your email address
                </Typography>

                {/* <Typography className={classes.fontStyle} gutterBottom>
                  OTP
                </Typography> */}
                <form onSubmit={handleSubmit}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    placeholder="Enter your OTP"
                    required
                    className={classes.fieldWrapper}
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />

                  {loading ? <LinearProgress /> : null}

                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.buttonStyle}
                    disabled={loading}
                    type="submit"
                  >
                    Continue
                  </Button>
                </form>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Footer />
        </Grid>
      </Grid>
    </div>
  );
};
export default OtpSend;
